export enum TableTypeEnum {
	parentTable = 'parentTable',
	childTable = 'childTable',
	sampleTable = 'sampleTable',
	standardTable = 'standardTable',
	flatTable = 'flatTable',
	flatSampleTable = 'flatSampleTable'
}
